import React, { useState } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  Button,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import { useForm } from "react-hook-form";
import { API_ENDPOINTS } from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import { toast } from "react-toastify";

function VerifyForm({ onVerify }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { isLoading, postData: verifyOrder } = usePostRequest(
    API_ENDPOINTS.GET_ORDER_VERIFICATION
  );

  const handleVerification = (formData) => {
    verifyOrder(
      {
        order_id: formData.orderId,
        email: formData.emailID,
      },
      (apiResponse) => {
        // onSuccess callback: apiResponse is response.data from axios
        if (apiResponse?.data) {
          onVerify(true, apiResponse);
        } else if (apiResponse?.message) {
          toast.error(apiResponse.message);
          onVerify(false);
        } else {
          onVerify(false);
        }
      },
      (error) => {
        toast.error(error);
        console.log(error);
      }
    );
  };

  return (
    <>
        <Form onSubmit={handleSubmit(handleVerification)}>
          <Row className="mb-3 mt-3">
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="required">Order ID</Form.Label>
                <InputGroup>
                  <Form.Control
                    {...register("orderId", {
                      required: "Order ID is required",
                    })}
                    placeholder="Enter Order ID"
                  />
                </InputGroup>
                {errors.orderId && (
                  <span className="text-danger">{errors.orderId.message}</span>
                )}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="required">Email</Form.Label>
                <InputGroup>
                  <Form.Control
                    {...register("emailID", {
                      required: "Email is required",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address",
                      },
                    })}
                    placeholder="Enter Email"
                  />
                </InputGroup>
                {errors.emailID && (
                  <span className="text-danger">{errors.emailID.message}</span>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={12} className="text-center">
              <Button type="submit" variant="warning" disabled={isLoading}>
                {isLoading ? "Verifying..." : "Verify"}
              </Button>
            </Col>
          </Row>
        </Form>
    </>
  );
}

export default VerifyForm;
